<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.sfjtqw">
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">水飞蓟提取物</span>
        </b>
      </p>
      <h1>
        <span style="font-size:12px;">Spec</span>
      </h1>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Appearance:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Light Yellow Powder
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Particle
          Size:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 100% through 80 mesh
        </span>
      </p>
      <p>
        <span
          style="font-size:12px;font-family:Arial;"
        >Assay:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Silymarin NLT 80%</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Loss
            on Drying&nbsp;&nbsp;&nbsp;&nbsp; &lt;5.0%
          </span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span
            style="font-size:12px;"
          >Ash:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt;0.8%</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Heavy
          Metals:
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Arsenic(As):&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt;
            2ppm
          </span>
          <span style="font-size:12px;">&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Lead(Pb):&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt;
            2ppm
          </span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span
          style="font-size:12px;font-family:Arial;"
        >Microbiology:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; non- irradiated</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Total Plate Count</span>
          <span></span>
          <span style="font-size:12px;">: NMT 5000cfu/g</span>
        </span>
      </p>
      <p>
        <span
          style="font-size:12px;font-family:Arial;"
        >Yeast &amp; Mold:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; NMT 300cfu/g</span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          E. coil:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Negative
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Salmonellae</span>
          <span></span>
          <span style="font-size:12px;">:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Negative</span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images:{
        sfjtqw:require('../../../assets/img/common/sfjtqw.jpg')
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/product/sfjtqw.vue